import styled from 'styled-components';
import { SecondaryButton } from 'ui/button';
import { backgroundColors, Body2, borderColors, borderRadius, spacing } from 'ui/theme';

export const LogoFieldWrapper = styled.div`
  display: inline-flex;
`;

export const LogoField = styled.div`
  display: grid;
  grid-template-areas: 'thumbnail details remove';
  grid-template-columns: auto 1fr auto;
  align-items: center;
  column-gap: ${spacing.plusQuarter};
  row-gap: ${spacing.quarter};
  justify-content: center;
  width: 100%;
  padding: ${spacing.plusThreeQuarter} ${spacing.plusQuarter};
  margin-bottom: ${spacing.base};
  border: ${spacing.single} solid ${borderColors.borderPrimary};
  border-radius: ${borderRadius.md};
`;

export const Details = styled.div`
  grid-area: details;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  row-gap: ${spacing.quarter};
`;

export const Thumbnail = styled.img`
  grid-area: thumbnail;
  display: block;
  max-height: ${spacing.x4};
  width: auto;
  background-color: ${backgroundColors.backgroundSecondary};
  border-radius: ${borderRadius.md};
`;

export const FileName = styled(Body2)`
  margin-bottom: 0;
`;

export const ReplaceButton = styled(SecondaryButton)`
  align-self: center;
  grid-area: remove;
  justify-self: end;
`;

export const FileInput = styled.input`
  &[type='file'] {
    display: none;
  }
`;
